import * as go from 'gojs/release/go-module';

import { ModelSnapshot } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isModelConceptHierarchy,
  isModelConceptRelationship,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { getLabelKeyFromMappingKey } from 'src/containers/ProjectDiagram/utils/mapping/createMappingLabel';
import { getLabelKeyFromHierarchyKey } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';
import { getLabelKeyFromRelationshipKey } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/createModelConceptRelationshipLabel';

// when undoing a transaction that resulted in the key of a label node changing,
// the `labelKeys` property of a link can become an empty array, instead of
// what it was before the transaction. This will not cause the link & label to
// disconnect on the diagram immediately, but will cause problems the next time
// the diagram is loaded from the ModelSnapshot
export const fixLabelReferencesInSnapshot = (snapshot: ModelSnapshot) => {
  if (!snapshot.linkDataArray) {
    return snapshot;
  }

  const newLinkDataArray = snapshot.linkDataArray.map((linkData) => {
    let linkLabelKeys = [linkData.labelKeys[0]];
    if (isModelConceptRelationship(linkData)) {
      linkLabelKeys = [getLabelKeyFromRelationshipKey(linkData.key)];
    } else if (isModelConceptHierarchy(linkData)) {
      linkLabelKeys = [getLabelKeyFromHierarchyKey(linkData.key)];
    } else if (isMapping(linkData)) {
      linkLabelKeys = [getLabelKeyFromMappingKey(linkData.key)];
    } else if (isRelationshipMapping(linkData)) {
      linkLabelKeys = [];
    }
    return { ...linkData, labelKeys: [...linkLabelKeys] };
  });

  return { ...snapshot, linkDataArray: newLinkDataArray };
};

export const transformModelToSnapshot = (model: go.Model) => {
  const modelSnapshot = JSON.parse(model.toJson()) as ModelSnapshot;
  modelSnapshot.modelData.selection = [];
  modelSnapshot.modelData.highlighted = null;
  return fixLabelReferencesInSnapshot(modelSnapshot);
};
